import * as z from "zod";

export enum ConversionHealthCheckStatus {
  UNAVAILABLE = "UNAVAILABLE",
  AVAILABLE = "AVAILABLE",
}

export const getConversionHealthCheck = {
  name: "getConversionHealthCheck" as const,
  input: z.object({ teamId: z.string() }),
  output: z.union([
    z.object({
      status: z.literal(ConversionHealthCheckStatus.AVAILABLE),
      isActiveOnCheckoutPersonalization: z.boolean(),
      last24HoursBilledOrderCount: z.number(),
      last24HoursBilledOrderRevenue: z.number(),
      last24HoursHasAdvancedAnalytics: z.boolean(),
      last7DaysBilledOrderCount: z.number(),
      last7DaysBilledOrderRevenue: z.number(),
      last7DaysHasAdvancedAnalytics: z.boolean(),
      lastHealthCheckAt: z.date(),
    }),
    z.object({ status: z.literal(ConversionHealthCheckStatus.UNAVAILABLE) }),
  ]),
};
